/* eslint guard-for-in:0 */
/* global PortalL10n */

/**
 * PortalElementSearch
 */

const PortalEvent = require("./PortalEvent");
const { log, error } = require("./PortalLogging");
const PortalApi = require("./PortalApi");
const PortalElementBase = require("./PortalElementBase");
const { l10n } = require("./PortalL10n");
const PortalUtils = require("./Utils/utils.js")
// const { facetIndex } = require("./portalConnect");

let FacetIndex = require("./facetIndex");

// console.log("FACES" , FacetIndex.array['Author'])

const props = ["el"];
let facetTitle = [];

PortalEvent.register("newSearch");
PortalEvent.register("aggregMore");
PortalEvent.register("aggregPurl");
PortalEvent.register("collapseFacet");
PortalEvent.register("expandFacet");
PortalEvent.register("setClickEventsAfterReload");
PortalEvent.register("sort&Limit");
PortalEvent.register("newLogin");
PortalEvent.register("resetLogin");
PortalEvent.register("logout");
PortalEvent.register("newRegister");
PortalEvent.register("resetRegister");
PortalEvent.register("closeLoginOpenRegister");
PortalEvent.register("aggregLess");
PortalEvent.register("showSpinner");
PortalEvent.register("hideSpinner");
PortalEvent.register("closeLoginPopup");

module.exports = class PortalElementSearch extends PortalElementBase {
  constructor(opts = {}) {
    props.forEach((prop) => {
      if (opts[prop] === undefined)
        throw new Error(
          `Missing required prop "${prop}" for PortalElementSearch`
        );
    });

    log("new PortalElementSearch", opts);

    super(opts);
    // console.log(opts);
    Object.assign(this, {});

    if (typeof this.display.detail_link_url_postfix != "defined") {
      this.display.detail_link_url_postfix = "";
    }
    this.searchFields = [];
    this.searchFilters = {};
    this.filterChanged = {};
    this.setAggregations();

    // set start Filters
    this.setFilterInit();

    if (
      typeof this.aggregations != "undefined" &&
      typeof this.aggregations._objecttype != "undefined"
    ) {
      this.api.easydbL10N().then((ret) => {
        this.easydb_l10n = ret;
      });
    }

    this.setEventForSearch();
    this.setEventForAggregMore();
    this.setEventForAggregPurl();
    this.setClickEventsAfterReload();
    this.setEventForSortfuncLimitfunc();
    this.loginModalHTML = $("#loginModal").html();
    this.registerModalHTML = $("#registerModal").html();

    // Standard Events, die eine neue Suche auslösen:
    // Klick auf Search-Button
    this.registerClickEventForSearchButton();

    // Change, falls Limit und Sort Form-Elemente sind
    this.registerChangeEventForLimit();

    // Return in Suchfeld
    this.registerEventForEnterButtonPress();

    // Eine neue Suchanfrage kann auch per Script ausgelöst werden:
    // PortalEvent.emit('newSearch',<Target-ID aus Konfiguration>)

    // Übergebene Suchanfrage auswerten
    this.searchFromUrl();

    // Wenn Parameter autosearch gesetzt, automatisch Suche auslösen
    if (this.autosearch) {
      PortalEvent.emit("newSearch", this.target);
    }

    this.search_languages = this.sorted_languages_array;
    this.setEventForLogin();
    this.registerClickEventForLogin();
    this.registerEventToResetLoginModal();
    this.setEventForResetLoginModal();
    this.registerClickEventForLogout();
    this.setEventForLogOut();
    this.registerClickEventForSendEmail();
    this.setEventForRegister();
    this.registerEventToResetRegisterModal();
    this.setEventForResetRegisterModal();
    this.registerEventForRegisterViaLogin();
    this.setEventForRegisterViaLogin();
    this.setEventForAggregLess();
    this.registerEventForSpinner();
    this.registerEventForGuestUserViaLogin();
    this.setEventForGuestUserViaLogin();
    this.showLoginPopupByDefault(opts.shouldShowLoginPopupByDefault);

  }

  searchOptionsFromForm(keepSearchFields) {
    // Read Page Size -- Seitengröße lesen
    this.limit = 50;
    if ($(this.target).find('[data-function="ep-limit"]').length) {
      if (
        $(this.target).find('[data-function="ep-limit"] option:checked').length
      ) {
        this.limit = parseInt(
          $(this.target).find('[data-function="ep-limit"] option:checked').val()
        );
      } else {
        this.limit = parseInt(
          $(this.target).find('[data-function="ep-limit"]').val()
        );
      }
    }
    // read sorting -- Sortierung lesen
    this.sort = [];
    this.sort.push(this.defaultSort);
    if ($(this.target).find('[data-function="ep-sort"]').length) {
      if (
        $(this.target).find('[data-function="ep-sort"] option:checked').length
      ) {
        this.sort.push(...(JSON.parse(
          $(this.target).find('[data-function="ep-sort"] option:checked').val()
        )));
      } else {
        this.sort.push(...(JSON.parse(
          $(this.target).find('[data-function="ep-sort"]').val()
        )));
      }
    }

    // offset: currently selected offset in paging hit list -- offset: aktuell gewählter offset bei Paging Trefferliste
    this.offset = 0;
    if (!keepSearchFields) {
      // searchFilters: currently selected search filters -- searchFilters: aktuell gewählte Suchfilter
      this.searchFilters = {};
      // set start Filters
      this.setFilterInit();
    }
  }

  setFilterInit() {
    Object.keys(this.aggregations).forEach((a) => {
      if (
        typeof this.aggregations[a].init == "object" &&
        Array.isArray(this.aggregations[a].init)
      ) {
        this.searchFilters[a] = this.aggregations[a].init;
      }
    });
  }

  suggest(suggestRequest) {
    return this.api.suggest(suggestRequest);
  }


  setBgColorForFiltersDiv() {
    $(this.target)
        .find("#aggregations")
        .each((i, el) => {
          $(el).css("background-color", "#eee");
        });
  }

  setBorderForPageNumberBar() {
    $(this.target)
        .find(".page-number-bar")
        .each((i, el) => {
          $(el).css("border", "1px solid grey");
        });
  }

  setClickEventsForResults() {
    if (typeof this.display.detail_thumb_click_handler == "function") {
      $(this.target)
        .find('[data-function="ep-hits"] .ep-thumb')
        .on("click", (e) => this.display.detail_thumb_click_handler(e));
    }
  }

  setClickEventsForResultsSwitchsTitle() {
    $(this.target)
        .find('[data-function="ep-hits"] .ep-detail-switch')
        .html(l10n("Details", PortalL10n.lang));
    $(this.target)
      .find('[data-function="ep-hits"] .ep-detail-title')
      .on("click", (e) => {
        $(e.currentTarget).nextAll(".ep-detail-switch").eq(0).click();
      });
  }

  getAktPages(result) {
    let pages = 0;
    let akt_page = 0;
    if (result.count > 0) {
      pages = Math.floor(result.count / result.limit);
      if (result.count % result.limit) {
        pages++;
      }
      akt_page = parseInt(result.offset / result.limit) + 1;
    }
    return {akt_page: akt_page, pages: pages};
  }

  setResultsHitText(result) {
    $(this.target)
        .find('[data-function="ep-hits-count"]')
        .html(
          result.count.toLocaleString(PortalL10n.lang) +
            " " +
            l10n("Treffer", PortalL10n.lang)
        );
  }

  setNumOfPagesText(akt_page, pages) {
    $(this.target)
        .find('[data-function="ep-pages-count"]')
        .html(
          akt_page.toLocaleString(PortalL10n.lang) +
            " / " +
            pages.toLocaleString(PortalL10n.lang)
        );
  }

  removeClickHandlers() {
    $(this.target).find('[data-function="ep-pages-first"]').off("click");
    $(this.target).find('[data-function="ep-pages-back"]').off("click");
    $(this.target).find('[data-function="ep-pages-forw"]').off("click");
    $(this.target).find('[data-function="ep-pages-last"]').off("click");
  }

  enableFirstPageButton() {
    $(this.target)
      .find('[data-function="ep-pages-first"]')
      .removeAttr("disabled");
  }

  enablePreviousPageButton() {
    $(this.target)
      .find('[data-function="ep-pages-back"]')
      .removeAttr("disabled");
  }
  

  registerClickEventForFirstPageButton(searchRequest) {
    $(this.target)
      .find('[data-function="ep-pages-first"]')
      .on("click", () => {
        searchRequest.offset = 0;
        this.offset = searchRequest.offset;
        this.search(searchRequest);
        event.preventDefault();
        window.scrollTo(0, 0);
      });
  }

  registerClickEventForPreviousPageButton(searchRequest) {
    $(this.target)
      .find('[data-function="ep-pages-back"]')
      .on("click", () => {
        searchRequest.offset -= searchRequest.limit;
        if (searchRequest.offset < 0) {
          searchRequest.offset = 0;
        }
        this.offset = searchRequest.offset;
        this.search(searchRequest);
        event.preventDefault();
        window.scrollTo(0, 0);
      });
  }

  search(searchRequest) {
    // spin Search button (looks ugly)
    // $(this.target).find('[data-function="ep-searchbut"] span.fa').addClass('fa-spin')
    // alert(searchRequest)

    this.api.search(searchRequest).then((result) => {
      // background-color erst hier grau machen, damit #aggregations vor Start der Suche nicht sichtbar ist
      this.setBgColorForFiltersDiv();
      this.setBorderForPageNumberBar();

      // stop Search button from spinning
      // $(this.target).find('[data-function="ep-searchbut"] span.fa-spin').removeClass('fa-spin')
      // Ergebnis-Liste darstellen
      $(this.target)
        .find('[data-function="ep-hits"]')
        .html(this.renderObjects(result));

      // console.log("OBJKJK", result);

      // Ggf. Klick-Event registrieren
      this.setClickEventsForResults();
      this.setClickEventsForResultsSwitchsTitle()
      
      this.setResultsHitText(result);
      let aktPages = this.getAktPages(result);
      this.setNumOfPagesText(aktPages.akt_page, aktPages.pages);
      this.removeClickHandlers();

      if (aktPages.akt_page > 1) {
        this.enableFirstPageButton();
        this.enablePreviousPageButton();
        this.registerClickEventForFirstPageButton(searchRequest);
        this.registerClickEventForPreviousPageButton(searchRequest);
      } else {
        $(this.target)
          .find('[data-function="ep-pages-first"]')
          .attr("disabled", "disabled");
        $(this.target)
          .find('[data-function="ep-pages-back"]')
          .attr("disabled", "disabled");
      }

      if (aktPages.akt_page < aktPages.pages) {
        $(this.target)
          .find('[data-function="ep-pages-last"]')
          .removeAttr("disabled");
        $(this.target)
          .find('[data-function="ep-pages-forw"]')
          .removeAttr("disabled");
        $(this.target)
          .find('[data-function="ep-pages-forw"]')
          .on("click", () => {
            searchRequest.offset += searchRequest.limit;
            this.offset = searchRequest.offset;
            this.search(searchRequest);
            event.preventDefault();
            window.scrollTo(0,0);
          });
        $(this.target)
          .find('[data-function="ep-pages-last"]')
          .on("click", () => {
            searchRequest.offset = (aktPages.pages - 1) * searchRequest.limit;
            this.offset = searchRequest.offset;
            this.search(searchRequest);
            event.preventDefault();
            window.scrollTo(0,0);
          });
      } else {
        $(this.target)
          .find('[data-function="ep-pages-forw"]')
          .attr("disabled", "disabled");
        $(this.target)
          .find('[data-function="ep-pages-last"]')
          .attr("disabled", "disabled");
      }

      if (result.count > 0) {
        $(this.target).find('[data-function="ep-pages-first"]').show();
        $(this.target).find('[data-function="ep-pages-back"]').show();
        $(this.target).find('[data-function="ep-pages-forw"]').show();
        $(this.target).find('[data-function="ep-pages-last"]').show();
        $(this.target).find('[data-function="ep-pages-count"]').show();

        // Filter-Liste darstellen
        $(this.target)
          .find('[data-function="ep-aggregations"]')
          .html("<div>" + this.renderAggregations(result, true) + "</div>");
        this.clickEventsAggreg();
      } else {
        $(this.target).find('[data-function="ep-aggregations"]').html("");
        $(this.target).find('[data-function="ep-pages-first"]').hide();
        $(this.target).find('[data-function="ep-pages-back"]').hide();
        $(this.target).find('[data-function="ep-pages-forw"]').hide();
        $(this.target).find('[data-function="ep-pages-last"]').hide();
        $(this.target).find('[data-function="ep-pages-count"]').hide();
      }
    }).catch((result) => {
        window.alert("Session has expired. You have been logged out. Please login again.");
        location.reload();
    });
  }

  clickEventsDetailLinkedObjects($context) {
    // Detailanzeigen zu verlinkten Objekten laden/anzeigen
    $context.find(".heidiconInfoBut").off("click");
    $context.find(".heidiconInfoBut").on("click", (e) => {
      let $container = $(e.target)
        .closest(".heidiconRow")
        .find(".heidiconObjDetail")
        .eq(0);
      if ($(e.target).hasClass("active")) {
        $(e.target).removeClass("active");
        $container.hide();
      } else {
        $(e.target).addClass("active");
        $container.show();
        if (!$container.attr("data-info-loaded")) {
          $container.html('<span class="fa fa-spinner fa-spin"></span>');
          this.api.object($(e.target).attr("data-info-id")).then((result) => {
            $container.attr("data-info-loaded", "yes");
            let res = $(result).find(".heidiconDetail").length
              ? $(result).find(".heidiconDetail")
              : $(result);
            // Thumbs bei Ressourcen nur anzeigen, wenn mehr als eine Res.
            if (res.find(".heidiconAssetThumb").length <= 1) {
              res.find(".heidiconAssetThumb").remove();
            }
            res.find(".heidiconAssetTools").remove();
            res.find(".heidiconDeepLink").remove();
            res.find(".heidiconPool").remove();
            $container.html(res.html());
          });
        }
      }
      e.preventDefault();
    });
  }

  clickEventsAggreg() {

    $(this.target).find(".filter-title.selectable").off("click");
    $(this.target)
      .find(".filter-title.selectable")
      .on("click", (filtereintrag) => {        
        this.addFilter($(filtereintrag.target));
      });
    $(this.target).find(".bin-icon.selected").off("click");
    // console.log($(this.target).find(".ep-aggreg-del-disp"))
    $(this.target)
      .find(".bin-icon.selected")
      .on("click", (filtereintrag) => {
        this.removeFilter($(filtereintrag.target));
      });
    $(this.target).find(".ep-aggreg-reset-all").off("click");
    $(this.target)
      .find(".ep-aggreg-reset-all")
      .on("click", (filtereintrag) => {
        // const facetHead = $(filtereintrag.target).closest('.facet-title').attr('class').substring(0, $(filtereintrag.target).closest('.facet-title').attr('class').length-11).trimEnd();
        // facetTitle.indexOf(facetHead) === -1 ?  console.log("no") : facetTitle.splice(facetTitle.indexOf(facetHead, 1));
        // console.log(facetTitle)
        // this.removeClass("ep-aggreg-reset-all")
        this.removeFilterAll($(filtereintrag.target));
      });
    $(this.target).find(".more-button-title").off("click");
    $(this.target)
      .find(".more-button-title")
      .on("click", (filtereintrag) => {
        PortalEvent.emit("aggregMore", this.target, $(filtereintrag.target));
      });
    $(this.target).find(".ep-aggreg-purl-switch").off("click");
    $(this.target)
      .find(".ep-aggreg-purl-switch")
      .on("click", (filtereintrag) => {
        PortalEvent.emit("aggregPurl", this.target, $(filtereintrag.target));
      });
    $(this.target).find(".ep-aggreg-purl-url").off("click");
    $(this.target)
      .find(".ep-aggreg-purl-url")
      .on("click", (f) => {
        $(f.target).selectText();
        document.execCommand("copy");
      });
    $(this.target).find(".less-button-title").off("click");
    $(this.target)
      .find(".less-button-title")
      .on("click", (filtereintrag) => {
        PortalEvent.emit("aggregLess", this.target, $(filtereintrag.target));
      });
    this.setExpandCollapseClickEvents();
  }

  setExpandCollapseClickEvents() {
    $(this.target).find(".aggregation-collapse-icon").off("click");
    $(this.target).find(".aggregation-expand-icon").off("click");

    $(this.target).find(".aggregation-collapse-icon").on("click", (f) => {
      PortalEvent.emit("collapseFacet", this.target, $(f.target), this.clickEventsAggreg);
    })

    $(this.target).find(".aggregation-expand-icon").on("click", (f) => {
      PortalEvent.emit("expandFacet", this.target, $(f.target), this.clickEventsAggreg);
    })
  }

  searchFromUrl() {
    // TODO: Refactor this method
    let hurl = window.location.hash;
    let autosearch = {};
    // alert("SUS")
    if (hurl.length) {
      hurl = hurl.substr(1);
      if (hurl.match(/^id:([0-9]+)$/)) {
        autosearch = {
          search: [{ field: "_system_object_id", term: parseInt(RegExp.$1) }],
        };
      } else if (hurl.match(/^filter:([0-9]+):/)) {
        let filterNr = parseInt(RegExp.$1);
        let filterName = "";
        Object.keys(this.aggregations).forEach((f) => {
          if (
            typeof this.aggregations[f].index != "undefined" &&
            this.aggregations[f].index == filterNr
          ) {
            filterName = f;
          }
        });
        if (filterName != "") {
          let filterValue = decodeURI(hurl.replace(/^filter:([0-9]+):/, ""));
          try {
            let fobj = {};
            fobj[filterName] = JSON.parse(filterValue);
            // Bei hierarchischen Facetten, fehlende (übergeordnete) Einträge
            // ergänzen
            if (
              typeof this.aggregations[filterName].filter_parent !=
                "undefined" &&
              this.aggregations[filterName].type == "linked_object"
            ) {
              let ancestors = [];
              fobj[filterName].forEach((el) => {
                if (el.match(/^[0-9\.]+$/)) {
                  let elparts = el.split(".");
                  let newel = "";
                  for (let i = 0; i < elparts.length; i++) {
                    if (newel) {
                      newel += ".";
                    }
                    newel += elparts[i];
                    if (!fobj[filterName].includes(newel)) {
                      ancestors.push(newel);
                    }
                  }
                }
              });
              ancestors.forEach((a) => {
                fobj[filterName].push(a);
              });
            }
            autosearch = { filter: fobj };
          } catch (e) {}
        }
      } else {
        try {
          let base = window.atob(hurl);
          try {
            autosearch = JSON.parse(base);
          } catch (e) {}
        } catch (e) {}
      }
    }
    let startSearch = false;

    // Direkteinstieg: Filter gesetzt?
    if (typeof autosearch.filter == "object") {
      this.searchFilters = autosearch.filter;
      startSearch = true;
      Object.keys(this.searchFilters).forEach((k) => {
        this.filterChanged[k] = true;
      });
    }

    // Direkteinstieg: Suche übergeben?
    if (
      typeof autosearch.search == "object" &&
      Array.isArray(autosearch.search)
    ) {
      this.searchFields = autosearch.search;
      startSearch = true;
    }
    if (startSearch) {
      // Automatische Suche aus Formular deaktivieren, wenn Suche übergeben
      this.autosearch = false;
      let searchRequest = this.buildSearchRequest();
      this.search(searchRequest);
    }
  }

  addFilter(element) {
    let field = element.attr("data-aggreg");
    let aggreg_value = element.attr("data-aggreg-value");
    this.filterChanged[field] = true;
    let type = this.aggregations[field].type;
    let hierarchy =
      typeof this.aggregations[field].filter_parent != "undefined"
        ? true
        : false;

    if (typeof this.searchFilters[field] == "undefined") {
      this.searchFilters[field] = [];
    }

    // Wenn Eintrag schon vorhanden, diesen löschen.
    // Gleiches gilt für hierarchisch tiefer liegenden Einträgen
    let newFilters = [];
    this.searchFilters[field].forEach((fv) => {
      if (fv != aggreg_value) {
        let test_hier = fv.substr(0, aggreg_value.length) + ".";
        if (test_hier != aggreg_value + ".") {
          newFilters.push(fv);
        }
      }
    });
    this.searchFilters[field] = newFilters;

    this.searchFilters[field].push(aggreg_value);

    this.checkFilterIsChanged(field);

    let searchRequest = this.buildSearchRequest();
    this.search(searchRequest);
  }

  removeFilterAll(element) {
    let field = element.parents("div[data-aggreg]").attr("data-aggreg");
    if (typeof this.searchFilters[field] != "undefined") {
      delete this.searchFilters[field];
      if (
        typeof this.aggregations[field] != "undefined" &&
        typeof this.aggregations[field].init != "undefined"
      ) {
        this.searchFilters[field] = this.aggregations[field].init;
      }
      this.filterChanged[field] = false;
      let searchRequest = this.buildSearchRequest();
      this.search(searchRequest);
    }
  }

  removeFilter(element) {
    let field = element.attr("data-aggreg");
    let aggreg_value = element.attr("data-aggreg-value");
    this.filterChanged[field] = true;
    let type = this.aggregations[field].type;
    if (typeof this.searchFilters[field] != "undefined") {

      if (type == "linked_object") {
        const new_field_regex = new RegExp(`(${aggreg_value}|\\.${aggreg_value}|\\:${aggreg_value}).*`);
        let new_fields_array = [];
        this.searchFilters[field].forEach(old_field => {
          let result_field = old_field.replace(new_field_regex, '');
          if (result_field) { new_fields_array.push(result_field); this.filterChanged[field] = true; }
        });

        if (!new_fields_array.length) {  
          delete this.searchFilters[field];
          this.filterChanged[field] = false;
        } else {
          this.searchFilters[field] = new_fields_array;
        }

        let searchRequest = this.buildSearchRequest();
        this.search(searchRequest);

      } else {
        let index = this.searchFilters[field].indexOf(aggreg_value);
        if (index !== -1) {
          if (type == "date_range") {
            let temp = [];
            for (let i = 0; i < index; i++) {
              temp.push(this.searchFilters[field][i]);
            }
            this.searchFilters[field] = temp;
          } else {
            this.searchFilters[field].splice(index, 1);
          }
          if (this.searchFilters[field].length <= 0) {
            delete this.searchFilters[field];
            this.filterChanged[field] = false;
          } else {
            this.checkFilterIsChanged(field);
          }
          let searchRequest = this.buildSearchRequest();
          this.search(searchRequest);
        }
      }
    }
  }

  checkFilterIsChanged(field) {
    let changed = 0;
    this.searchFilters[field].forEach((a) => {
      let found = 0;
      if (
        typeof this.aggregations[field].init == "object" &&
        Array.isArray(this.aggregations[field].init)
      ) {
        this.aggregations[field].init.forEach((b) => {
          if (a == b) {
            found = 1;
          }
        });
      }
      if (!found) {
        changed = 1;
      }
    });
    if (!changed) {
      this.filterChanged[field] = false;
    }
  }

  buildSuggestRequest(field, value) {
    let autocomplete_objecttypes =
      typeof this.autocomplete_objecttypes != "undefined"
        ? this.autocomplete_objecttypes
        : [];
    let autocomplete_languages =
      typeof this.autocomplete_languages != "undefined"
        ? this.autocomplete_languages
        : PortalL10n.default_autocomplete_lang;
    let suggestRequest = {
      objecttypes: this.objecttypes,
      pool_ids: this.pools,
      linked_objecttypes: autocomplete_objecttypes,
      limit: 10,
      analyze_wildcards: false,
      tokens: true,
      tokens_mode: "edgengram",
      fields_suggest: true,
      query: value,
      languages: autocomplete_languages,
    };
    if (typeof field != "undefined" && field.length) {
      suggestRequest["fields"] = [field];
    }
    return suggestRequest;
  }

  buildSearchRequest() {
    // Suchanfrage zusammenbauen
    let searchRequest = {
      offset: this.offset,
      limit: this.limit,
      generate_rights: false,
      search: [],
      language: PortalL10n.lang,
      format: "long",
      sort: this.sort,
      objecttypes: this.objecttypes,
    };

    // Objekttyp + Pool
    searchRequest.search.push(this.poolObjecttypeSearchPart());

    // Basesearch
    if (typeof this.basesearch != "undefined") {
      searchRequest.search.push(this.basesearch);
    }

    // Suchbegriffe
    if (typeof this.searchFields != "undefined" && this.searchFields.length) {
      searchRequest.search.push(this.searchFieldsPart());
    }

    // gewählte Filter
    this.searchFilterPart().forEach((fp) => {
      searchRequest.search.push(fp);
    });

    // Basis-Facetten
    if (
      typeof this.aggregations != "undefined" &&
      Object.keys(this.aggregations).length
    ) {
      searchRequest.aggregations = structuredClone(this.aggregations);
    }

    // Suchsprache
    //searchRequest.languages = ['en-US','de-DE']

    // Ergänzungen für hierarchische Facetten
    Object.keys(this.searchFilters).forEach((filterField) => {
      let hierarchy =
        typeof this.aggregations[filterField].filter_parent != "undefined" || this.aggregations[filterField].filter_parent != null
          ? true
          : false;
      let type = this.aggregations[filterField].type;
      if (hierarchy) {
        if (type == "date_range") {
          let last_path_el =
            this.searchFilters[filterField][
              this.searchFilters[filterField].length - 1
            ];
          let last_path_el_years =
            last_path_el.replace(/_.*$/, "").replace(/\-\d\d\-\d\d$/, "") +
            "_" +
            last_path_el.replace(/^.*_/, "").replace(/\-\d\d\-\d\d$/, "");
          let type = this.dateRangeType({
            from: last_path_el.replace(/_.*$/, ""),
            to: last_path_el.replace(/^.*_/, ""),
          });
          let path_add = "";
          this.searchFilters[filterField].forEach((fi) => {
            let jf = fi.replace(/_.*$/, "").replace(/\-\d\d\-\d\d$/, "");
            let jt = fi.replace(/^.*_/, "").replace(/\-\d\d\-\d\d$/, "");
            path_add += ":range_" + jf + "_" + jt;
          });
          if (type == "jahrtausend") {
            searchRequest.aggregations[filterField + path_add] = Object.assign(
              {},
              this.aggregations[filterField]
            );
            searchRequest.aggregations[filterField + path_add].ranges = [];
            let j = last_path_el
              .replace(/_.*$/, "")
              .replace(/\d\d\d\-\d\d-\d\d$/, "");
            for (let i = 0; i < 10; i++) {
              searchRequest.aggregations[filterField + path_add].ranges.push({
                from: j + i + "00-01-01",
                to: j + i + "99-12-31",
              });
            }
            delete searchRequest.aggregations[filterField];
            searchRequest.aggregations[filterField + path_add].filter_parent =
              "range_" + last_path_el_years;
          } else if (type == "jahrhundert") {
            searchRequest.aggregations[filterField + path_add] = Object.assign(
              {},
              this.aggregations[filterField]
            );
            searchRequest.aggregations[filterField + path_add].ranges = [];
            let j = last_path_el
              .replace(/_.*$/, "")
              .replace(/\d\d\-\d\d-\d\d$/, "");
            for (let i = 0; i < 10; i++) {
              searchRequest.aggregations[filterField + path_add].ranges.push({
                from: j + i + "0-01-01",
                to: j + i + "9-12-31",
              });
            }
            delete searchRequest.aggregations[filterField];
            searchRequest.aggregations[filterField + path_add].filter_parent =
              "range_" + last_path_el_years;
          } else if (type == "jahrzehnt") {
            searchRequest.aggregations[filterField + path_add] = Object.assign(
              {},
              this.aggregations[filterField]
            );
            searchRequest.aggregations[filterField + path_add].ranges = [];
            let j = last_path_el
              .replace(/_.*$/, "")
              .replace(/\d\-\d\d-\d\d$/, "");
            for (let i = 0; i < 10; i++) {
              searchRequest.aggregations[filterField + path_add].ranges.push({
                from: j + i + "-01-01",
                to: j + i + "-12-31",
              });
            }
            delete searchRequest.aggregations[filterField];
            searchRequest.aggregations[filterField + path_add].filter_parent =
              "range_" + last_path_el_years;
          } else {
            searchRequest.aggregations[filterField + path_add] = Object.assign(
              {},
              this.aggregations[filterField]
            );
            searchRequest.aggregations[filterField + path_add].ranges = [];
            searchRequest.aggregations[filterField + path_add].ranges.push({
              from: last_path_el.replace(/_.*$/, ""),
              to: last_path_el.replace(/^.*_/, ""),
            });
            delete searchRequest.aggregations[filterField];
            searchRequest.aggregations[filterField + path_add].filter_parent =
              "range_" + last_path_el_years;
          }
        } else if (type == "linked_object") {
          this.searchFilters[filterField].forEach((fi) => {
            searchRequest.aggregations[filterField + ":" + fi] = Object.assign({}, this.aggregations[filterField]);
            let fi_parts = fi.split(/\./);
            searchRequest.aggregations[filterField + ":" + fi].filter_parent =
              parseInt(fi_parts[fi_parts.length - 1]);
          });
        } else {
          this.searchFilters[filterField].forEach((fi) => {
            searchRequest.aggregations[filterField + ":" + fi] = Object.assign({}, this.aggregations[filterField]);
            delete searchRequest.aggregations[filterField];
            let fi_parts = fi.split(/\./);
            searchRequest.aggregations[filterField + ":" + fi].filter_parent =
              parseInt(fi_parts[fi_parts.length - 1]);
          });
        }
      }
    });

    // Sprache für Facetten setzen
    if (typeof searchRequest.aggregations != "undefined") {
      Object.keys(searchRequest.aggregations).forEach((a) => {
        searchRequest.aggregations[a].language = PortalL10n.lang;
      });
    }

    return searchRequest;
  }

  searchFilterPart() {
    let searchPartFilter = [];
    Object.keys(this.searchFilters).forEach((filterField) => {
      let type = this.aggregations[filterField].type;
      let hierarchy =
        typeof this.aggregations[filterField].filter_parent != "undefined"
          ? true
          : false;

      this.searchFilters[filterField].forEach((fi) => {
        // hierarchische Facetten
        if (hierarchy && type == "linked_object") {
          let ids = fi.split(/\./);
          let searchPartFilterElement = { bool: "must", type: "in" };
          let f = [filterField];
          if (f == "_pool") {
            f = [];
            this.objecttypes.forEach((element) => {
              f.push(element + "._pool._path.pool._id");
            });
          } else {
            let f_new = [];
            f.forEach((element) => {
              if (element === "objekte._nested:objekte__obj_autoren_lok.obj_autor_lok&&lokal_klass_person") {
                element = element.replace("&&", "._path.");
              } else {
                element = element.replace(/\//, "._path.");
              }
              element += "._id";
              f_new.push(element);
            });
            f = f_new;
          }
          // Facette auf Feld oder auf verlinkten Objekttyp (objekttypenübergreifend)?
          if (typeof this.aggregations[filterField].field != "undefined") {
            searchPartFilterElement.fields = f;
          } else {
            searchPartFilterElement.objecttype = f[0];
            searchPartFilterElement.include_path = true;
          }
          searchPartFilterElement.in = [parseInt(ids[ids.length - 1])];
          searchPartFilter.push(searchPartFilterElement);
        }
        // einfache Facetten
        else {
          let searchPartFilterElement = { bool: "must", type: "in" };
          // term
          if (type == "term" || type == "asset") {
            searchPartFilterElement.fields = [filterField];
            searchPartFilterElement.in = [fi];
          }
          // linked object
          else if (type == "linked_object") {
            let f = filterField;
            // Facette auf Feld oder auf verlinkten Objekttyp (objekttypenübergreifend)?
            if (typeof this.aggregations[filterField].field != "undefined") {
              f = f.replace(/\//, ".");
              f += "._id";
              searchPartFilterElement.fields = [f];
            } else {
              searchPartFilterElement.objecttype = f;
              searchPartFilterElement.include_path = true;
            }
            searchPartFilterElement.in = [parseInt(fi)];
          } else if (type == "date_range") {
            searchPartFilterElement.type = "range";
            searchPartFilterElement.field = filterField;
            searchPartFilterElement.from = fi.replace(/_.*$/, "");
            searchPartFilterElement.to = fi.replace(/^.*_/, "");
          } else {
          }
          searchPartFilter.push(searchPartFilterElement);
        }
      });
    });
    return searchPartFilter;
  }

  searchFieldsPart() {
    let searchPart = { type: "complex", __filter: "SearchInput", search: [] };
    this.searchFields.forEach((sf) => {
      let element = {
        type: "match",
        bool: "must",
        languages: this.search_languages
      };
      if (typeof sf.field != "undefined" && sf.field.length) {
        element.fields = sf.field.split(";");
        if (sf.field === "objekte._nested:objekte__obj_herstellungsorte.obj_herstellungsort_gnd.conceptName") {
          element.fields.push("objekte._nested:objekte__obj_herstellungsorte.obj_herstellungsort_gnd.conceptURI");
          element.fields.push("objekte._nested:objekte__obj_herstellungsorte.obj_herstellungsort_gnd.conceptSeeAlso");
        }
        if (sf.field == "_system_object_id") {
          element.in = [sf.term];
          element.type = "in";
        } else {
          element.string = sf.term;
          element.mode = "fulltext";
          element.phrase = false;
        }
      } else {
        element.string = sf.term;
        element.mode = "fulltext";
        element.phrase = false;
      }
      searchPart.search.push(element);
    });
    return searchPart;
  }

  searchChildren(id, element) {
    let fields = [];
    if (id) {
      this.objecttypes.forEach((o) => {
        fields.push(o + "._id_parent");
      });
      let searchRequest = {
        offset: 0,
        limit: 100,
        search: [{ type: "in", bool: "must", fields: fields, in: [id] }],
        format: "standard",
        sort: [{ field: "_standard.1.text", order: "ASC" }],
        objecttypes: this.objecttypes,
      };
      this.api.search(searchRequest).then((result) => {
        result.objects.forEach((o) => {
          let newel_html =
            '<div class="heidiconLinkObj"><div class="heidiconRow">';
          ["de-DE", "en-US"].forEach((l) => {
            if (typeof o._standard["1"].text[l] != "undefined") {
              newel_html +=
                '<div class="heidiconRowL10N"><div class="heidiconL10NValue"><span>' +
                o._standard["1"].text[l] +
                "</span>";
              newel_html +=
                '<span class="heidiconInfoBut" data-info-id="' +
                o._system_object_id +
                '"></span></div>';
              newel_html +=
                '<div class="heidiconL10NLang" data-lang="' +
                l +
                '"></div></div><div class="heidiconObjDetail"></div>';
            }
          });
          newel_html += "</div></div>";
          element.find("div.heidiconGroupStart").eq(0).append(newel_html);
        });
        element.show();
        this.clickEventsDetailLinkedObjects(element);
      }).catch((result) => {
        window.alert("Session has expired. You have been logged out. Please login again.");
        location.reload();
    });
    }
  }

  setAggregations() {
    Object.keys(this.aggregations).forEach((a) => {
      this.filterChanged[a] = false;
      if (this.aggregations[a].type == "date_range") {
        if (typeof this.aggregations[a].ranges == "undefined") {
          this.aggregations[a].ranges = [];
        }
        if (this.aggregations[a].ranges.length < 1) {
          this.aggregations[a].ranges.push(
            { from: "-9999-01-01", to: "-1000-12-31" },
            { from: "-0999-01-01", to: "-0900-12-31" },
            { from: "-0899-01-01", to: "-0800-12-31" },
            { from: "-0799-01-01", to: "-0700-12-31" },
            { from: "-0699-01-01", to: "-0600-12-31" },
            { from: "-0599-01-01", to: "-0500-12-31" },
            { from: "-0499-01-01", to: "-0400-12-31" },
            { from: "-0399-01-01", to: "-0300-12-31" },
            { from: "-0299-01-01", to: "-0200-12-31" },
            { from: "-0199-01-01", to: "-0100-12-31" },
            { from: "-0099-01-01", to: "-0001-12-31" },
            { from: "0001-01-01", to: "0999-12-31" },
            { from: "1000-01-01", to: "1099-12-31" },
            { from: "1100-01-01", to: "1199-12-31" },
            { from: "1200-01-01", to: "1299-12-31" },
            { from: "1300-01-01", to: "1399-12-31" },
            { from: "1400-01-01", to: "1499-12-31" },
            { from: "1500-01-01", to: "1599-12-31" },
            { from: "1600-01-01", to: "1699-12-31" },
            { from: "1700-01-01", to: "1799-12-31" },
            { from: "1800-01-01", to: "1899-12-31" },
            { from: "1900-01-01", to: "1909-12-31" },
            { from: "1910-01-01", to: "1919-12-31" },
            { from: "1920-01-01", to: "1929-12-31" },
            { from: "1930-01-01", to: "1939-12-31" },
            { from: "1940-01-01", to: "1949-12-31" },
            { from: "1950-01-01", to: "1959-12-31" },
            { from: "1960-01-01", to: "1969-12-31" },
            { from: "1970-01-01", to: "1979-12-31" },
            { from: "1980-01-01", to: "1989-12-31" },
            { from: "1990-01-01", to: "1999-12-31" },
            { from: "2000-01-01", to: "2009-12-31" },
            { from: "2010-01-01", to: "2019-12-31" },
            { from: "2020-01-01", to: "2029-12-31" },
            { from: "2030-01-01", to: "2039-12-31" },
            { from: "2040-01-01", to: "2049-12-31" },
            { from: "2050-01-01", to: "2059-12-31" },
            { from: "2060-01-01", to: "2069-12-31" },
            { from: "2070-01-01", to: "2079-12-31" },
            { from: "2080-01-01", to: "2089-12-31" },
            { from: "2090-01-01", to: "2099-12-31" }
          );
        }
      }
    });
  }

  setEventForSearch() {
    PortalEvent.on("newSearch", (e, target) => {
      if (target == this.target) {
        this.searchFromForm();
      }
    });
  }

  setEventForSortfuncLimitfunc() {
    PortalEvent.on("sort&Limit", (e, target) => {
      if (target == this.target) {
        this.searchFromForm(true);
      }
    });
  }

  setEventForAggregMore() {
    PortalEvent.on("aggregMore", (e, target, filter) => {
      if (target == this.target) {
        filter.html(
          '<img src="https://www.ub.uni-heidelberg.de/bilder/activity.gif" alt="still loading">'
        );
        let filterName = filter.closest("[data-aggreg]").data("aggreg");
        var searchRequest = this.buildSearchRequest();
        searchRequest =  this.modifySearchRequestForMoreButtonClick(searchRequest, filterName);
        this.api.search(searchRequest).then((result) => {
          $(this.target)
            .find('[data-function="ep-aggregations"]')
            .html("<div>" + this.renderAggregations(result, true, true) + "</div>");
          this.clickEventsAggreg();
        }).catch((result) => {
          window.alert("Session has expired. You have been logged out. Please login again.");
          location.reload();
      });
      }
    });
  }

  modifySearchRequestForMoreButtonClick(searchRequest, filterName) {
    Object.keys(searchRequest.aggregations).forEach((a) => {
      let facetName = a.replace(/:[0-9\.]+$/, "");
      if (facetName == filterName) {
        searchRequest.aggregations[a].limit = new PortalUtils().getMaxLimitForExpansion(facetName);
      } else {
        delete searchRequest.aggregations[a];
      }
    });
    return searchRequest;
  }

  setEventForAggregPurl() {
    PortalEvent.on("aggregPurl", (e, target, filter) => {
      if (target == this.target) {
        $(filter).closest("[data-aggreg]").find(".ep-aggreg-purl").toggle();
      }
    });
  }

  registerClickEventForSearchButton() {
    $(this.target)
      .find('[data-function="ep-searchbut"]')
      .on("click", (e, f) => {
        PortalEvent.emit("newSearch", this.target);
      });
  }

  registerChangeEventForLimit() {
    $(this.target)
      .find('[data-function="ep-limit"], [data-function="ep-sort"]')
      .on("change", (e) => {
        PortalEvent.emit("sort&Limit", this.target);
      });
  }

  registerEventForEnterButtonPress() {
    $(this.target)
      .find('[data-function="ep-query"]')
      .on("keydown", (e) => {
        if (e.which == 13) {
          e.preventDefault();
          PortalEvent.emit("newSearch", this.target);
        }
      });
  }

  setClickEventsAfterReload() {
    PortalEvent.on("setClickEventsAfterReload", () => {
      this.clickEventsAggreg();
    });
  }

  registerClickEventForLogin() {
    $(this.target)
      .find('#inputLoginSubmit')
      .on("click", (e, f) => {
        PortalEvent.emit("newLogin", this.target);
      });
  }

  setEventForLogin() {
    PortalEvent.on("newLogin", (e, target) => {
      if (target == this.target) {
        let username = $("#inputUsername").val();
        let password = $("#inputPassword").val();
        if (username && password) {
          // Reset Session, token in Cookies if already existing.
          PortalStorage.clearOutCookie();
          this.authenticator.initiateLogin(username, password);
        } else {
          // Show error text for empty password/username input.
          this.resetLoginModal();
          $("#loginErrorText").css("display", "block");
        }
      }
    });
  }

  registerEventToResetLoginModal() {
    $(this.target)
    .find("#loginModal")
    .on("hidden.bs.modal", (e, f) => {
      PortalEvent.emit("resetLogin", this.target);
    });
  }

  setEventForResetLoginModal() {
    PortalEvent.on("resetLogin", (e, target) => {
      this.resetLoginModal();
    });
  }

  resetLoginModal() {
    $("#loginModal").html(this.loginModalHTML);
    this.registerClickEventForLogin();
    this.registerEventForRegisterViaLogin();
    this.registerEventForGuestUserViaLogin();
  }

  registerClickEventForLogout() {
    $(this.target)
      .find('#logOut')
      .on("click", (e, f) => {
        PortalEvent.emit("logout", this.target);
      });
  }

  setEventForLogOut() {
    PortalEvent.on("logout", (e, target) => {
      PortalStorage.clearOutCookie();
      window.location.reload();
    });
  }

  registerClickEventForSendEmail() {
    $(this.target)
      .find('#inputRegisterSubmit')
      .on("click", (e, f) => {
        PortalEvent.emit("newRegister", this.target);
      });
  }

  setEventForRegister() {
    PortalEvent.on("newRegister", (e, target) => {
      if (target == this.target) {
        let name = $("#inputName").val();
        let email = $("#inputemail").val();
        if (name && email) {
          this.authenticator.registerUser(name, email)
          .then((res) => {
            window.alert("Thank you! We will contact you soon.");
            window.location.reload();
          }, (res) => {
            window.alert("Sorry. Request Failed. Please try again later.");
            window.location.reload();
          } 
          );
        } else {
          // Show error text for empty password/username input.
          this.resetRegisterModal();
          $("#registerErrorText").css("display", "block");
        }
      }
    });
  }

  registerEventToResetRegisterModal() {
    $(this.target)
    .find("#registerModal")
    .on("hidden.bs.modal", (e, f) => {
      PortalEvent.emit("resetRegister", this.target);
    });
  }

  setEventForResetRegisterModal() {
    PortalEvent.on("resetRegister", (e, target) => {
      this.resetRegisterModal();
    });
  }

  resetRegisterModal() {
    $("#registerModal").html(this.registerModalHTML);
    this.registerClickEventForSendEmail();
  }

  registerEventForRegisterViaLogin() {
    $(this.target)
    .find("#registerRedirect")
    .on("click", (e, f) => {
      PortalEvent.emit("closeLoginOpenRegister", this.target);
    });
  }

  setEventForRegisterViaLogin() {
    PortalEvent.on("closeLoginOpenRegister", (e, target) => {
      $('#loginModal').modal('hide');
      $('#registerModal').modal('show');
    });
  }

  registerEventForGuestUserViaLogin() {
    $(this.target)
    .find("#guestLoginSubmit")
    .on("click", (e, f) => {
      PortalEvent.emit("closeLoginPopup", this.target);
    });
  }

  setEventForGuestUserViaLogin() {
    PortalEvent.on("closeLoginPopup", (e, target) => {
      $('#loginModal').modal('hide');
    });
  }

  setEventForAggregLess() {
    PortalEvent.on("aggregLess", (e, target, filter) => {
      if (target == this.target) {
        filter.html(
          '<img src="https://www.ub.uni-heidelberg.de/bilder/activity.gif" alt="still loading">'
        );
        let filterName = filter.closest("[data-aggreg]").data("aggreg");
        var searchRequest = this.buildSearchRequest();
        searchRequest =  this.modifySearchRequestForLessButtonClick(searchRequest, filterName);
        this.api.search(searchRequest).then((result) => {
          $(this.target)
            .find('[data-function="ep-aggregations"]')
            .html("<div>" + this.renderAggregations(result, true, true) + "</div>");
          this.clickEventsAggreg();
        }).catch((result) => {
          window.alert("Session has expired. You have been logged out. Please login again.");
          location.reload();
      });
      }
    });
  }

  modifySearchRequestForLessButtonClick(searchRequest, filterName) {
    Object.keys(searchRequest.aggregations).forEach((a) => {
      let facetName = a.replace(/:[0-9\.]+$/, "");
      if (facetName != filterName) {
        delete searchRequest.aggregations[a];
      }
    });
    return searchRequest;
  }

  registerEventForSpinner() {
    PortalEvent.on("showSpinner", (e, target) => {
      // Show the spinner
      $(this.target).find("#spinner").show();

    });
    PortalEvent.on("hideSpinner", (e, target) => {
      // Hide the spinner
      $(this.target).find("#spinner").hide();
    });
  }

  showLoginPopupByDefault(shouldShowLoginPopupByDefault) {
    if(shouldShowLoginPopupByDefault) {
      // Show the login page
      $('#loginModal').modal('show');

    }
  }

};



//////////////////
// WEBPACK FOOTER
// ./js/PortalElementSearch.js
// module id = 5
// module chunks = 0